import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import ConfirmationWithDescription from "src/components/ConfirmationWithDescription";
import { ReactVideoPlayer } from "src/components";

const VideoUI = ({
  inputs,
  setInputs,
  setModalChangeExe,
  setIsWorkoutCompleted,
  practiceType,
  handleSubmit,
  comment_data,
}) => {
  const [openExerciseAlert, setOpenExerciseAlert] = useState(false);

  const handleChangeComplete = (e) => {
    const { checked } = e.target;
    if (!checked) {
      setOpenExerciseAlert(true);
      return;
    }

    setInputs({
      ...inputs,
      ["is_completed"]: checked,
    });
    if (checked) {
      handleSubmit(true, true);
    }
  };
  const handleAgreeInExerciseSet = () => {
    setIsWorkoutCompleted(false);
    setModalChangeExe(true);
    setOpenExerciseAlert(false);
    setInputs({
      ...inputs,
      ["is_completed"]: false,
    });
  };

  return (
    <div className="my-2">
      <ConfirmationWithDescription
        open={openExerciseAlert}
        setOpen={setOpenExerciseAlert}
        title={"Are you sure you want to take this action?"}
        descriotion={`If you uncheck, your points or coins allocated for this ${practiceType} will be deducted.`}
        handleAgree={handleAgreeInExerciseSet}
        isJustForOk={false}
      />
      <div className="characters mt-2">
        <div className="row justify-content-center">
          <div className="col-sm-12 col-md-12">
            {practiceType === "comment" ? (
              <TextField
                id="comment-text"
                label="Comment"
                placeholder="Comment"
                variant="outlined"
                fullWidth
                multiline
                rows={6}
                name="comment"
                value={comment_data?.editData?.comment}
                disabled
              />
            ) : (
              <ReactVideoPlayer url={inputs.video_url} />
            )}

            <div className="d-flex justify-content-end mt-3">
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{ p: "3px" }}
                      checked={
                        inputs?.is_completed ? inputs?.is_completed : false
                      }
                    />
                  }
                  onChange={(e) => handleChangeComplete(e)}
                  label="Mark as Complete"
                />
              </FormGroup>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default VideoUI;
